import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {requestAdminUser, requestEditAdminUser} from '../../actions/action_admin_user';
import {requestSurveyTrackersArchiveUpdate} from '../../actions/action_survey_trackers';
import Title from '../Title';
import UserEditForm from './UserEditForm';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';

class UserEdit extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.props.requestAdminUser(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.requestAdminUser(this.props.match.params.id);
        }
        if (this.props.item && !this.props.error && !this.props.submitting && this.props.submitting !== prevProps.submitting) {
            this.props.history.push('/admin/users');
        }
    }

    handleSubmit(data) {
        const values = {
            email: data.email,
            name: data.name,
            enabled: data.enabled,
            roles: data.roles,
            organization: {
                allowEvents: data.organization.allowEvents,
                allowAnalytics: data.organization.allowAnalytics,
                name: data.organization.name,
                // pinpointAppId: data.organization.pinpointAppId,
                tenantId: data.organization.tenantId,
                emailFrom: data.organization.emailFrom,
                emailFromName: data.organization.emailFromName,
                smsFrom: data.organization.smsFrom,
                sendProviders: data.organization.sendProviders,
                trackerArchiveFrequency: data.organization.trackerArchiveFrequency,
                trackerArchiveFrequencyValue: data.organization.trackerArchiveFrequencyValue,
                allowTrackerArchiveManagement: !!data.organization.allowTrackerArchiveManagement,
            },
        };

        if (data.password) {
            values.password = data.password;
        }
        this.props.requestEditAdminUser(this.props.match.params.id, values);
    }

    render() {
        const {item, loading, error, submitting} = this.props;
        return (
            <div className="row">
                <div className="col-md-2 col-12">
                    <Link className="btn btn-outline-primary btn-sm" to="/admin/users">
                        <Icon icon="arrow_left" /> <FormattedMessage {...messages.buttons.back} />
                    </Link>
                </div>
                <div className="col-md-8 col-12">
                    <Title><FormattedMessage {...messages.admin.users.edit} /></Title>
                    {item && (
                        <UserEditForm
                            item={item}
                            error={error}
                            onSubmit={this.handleSubmit}
                            loading={loading || submitting}
                            onSync={this.props.requestSurveyTrackersArchiveUpdate}
                        />
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.admin.users.item,
        loading: state.admin.users.loading,
        error: state.admin.users.error,
        submitting: state.admin.users.submitting,
    };
};

export default connect(mapStateToProps, {requestAdminUser, requestEditAdminUser, requestSurveyTrackersArchiveUpdate})(UserEdit);
